export default [
  {
    path: '/apps/natureza-operacao/list',
    name: 'apps-natureza-operacao-list',
    component: () => import('@/views/cadastros-gerais/natureza-operacao/list/Index.vue'),
    meta: {
      pageTitle: 'Natureza Operação',
      resource: 'AdminHanes',
    },
  },
  // {
  //     path: '/apps/natureza-operacao/edit/:id',
  //     name: 'apps-natureza-operacao-edit',
  //     component: () => import('@/views/cadastros-gerais/natureza-operacao/natureza-operacao-edit/GrupoEstoqueEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Familia Comercial',
  //         resource: 'AdminHanes',
  //     },
  // },
];
